import React, { Component } from 'react'
import { ProductImagePlaceholder } from './.'
import PropTypes from 'prop-types'
import ImageGallery from 'react-image-gallery'
import ReactPlaceholder from 'react-placeholder'
import MediaQuery from 'react-responsive'
import WishlistHeart from 'Wishlist/WishlistHeart'
import 'react-image-gallery/styles/css/image-gallery.css'

class ProductImage extends Component {
  constructor (props) {
    super(props)
    this.handleLabelThumb = this.handleLabelThumb.bind(this)
  }

  handleLabelThumb () {
    const imgGalleryThumbnails = document.querySelectorAll('.image-gallery-thumbnail, .image-gallery-bullet')
    if (imgGalleryThumbnails && imgGalleryThumbnails.length > 0) {
      Array.from(imgGalleryThumbnails).forEach(imgGalleryThumbnail => {
        imgGalleryThumbnail.setAttribute('aria-hidden', 'true')
        imgGalleryThumbnail.setAttribute('aria-label', imgGalleryThumbnail.getAttribute('aria-label').replace('Go to', 'Ir para'))
      })
    }
    const imgGalleryThumbnailsContainer = document.querySelectorAll('.image-gallery-thumbnails-container')
    if (imgGalleryThumbnailsContainer && imgGalleryThumbnailsContainer.length > 0) {
      Array.from(imgGalleryThumbnailsContainer).forEach(imgGalleryThumbnailContainer => {
        imgGalleryThumbnailContainer.removeAttribute('aria-label')
      })
    }
    const imgGalleryThumbnailsContainerMobile = document.querySelectorAll('.image-gallery-bullets-container')
    if (imgGalleryThumbnailsContainerMobile && imgGalleryThumbnailsContainerMobile.length > 0) {
      Array.from(imgGalleryThumbnailsContainerMobile).forEach(bulletContainer => {
        bulletContainer.removeAttribute('aria-label')
      })
    }
    const imgGalleries = document.querySelectorAll('.image-gallery')
    if (imgGalleries && imgGalleries.length > 0) {
      Array.from(imgGalleries).forEach(imgGallery => {
        imgGallery.removeAttribute('aria-live')
      })
    }
  }
  hideThumbs (e, handleLabelThumb) {
    handleLabelThumb()
    return <div className='image-gallery-image'><img src={e.original} alt='' aria-hidden='true' /></div>
  }
  componentDidMount () {
    setTimeout(() => {
      this.handleLabelThumb()
    }, 3000)
  }
  render () {
    const isLoading = this.props.isLoading
    const isVoucher = this.props.isVoucher
    const images = this.props.images
    const imageUrl = this.props.imageUrl
    const sku = this.props.sku

    return (
      <ReactPlaceholder
        ready={!isLoading}
        customPlaceholder={<ProductImagePlaceholder voucher={isVoucher} />}
      >
        <div className={`product-image overflow ${!images ? 'voucher' : ''}`}>
          <WishlistHeart sku={sku} className='card-wishlist pos-absolute' />
          <div className='imageGallery-box' aria-hidden='true'>
            <MediaQuery maxDeviceWidth={767}>
              <ImageGallery
                showPlayButton={false}
                showFullscreenButton={false}
                useBrowserFullscreen={false}
                showNav={false}
                showBullets
                showThumbnails={false}
                disableKeyDown
                disableArrowKeys
                disableSwipe
                items={images
                  ? images.map(img => ({
                    original: img.largeImage || img.mediumImage,
                    thumbnail: img.smallImage,
                    thumbnailClass: 'radius mt-2',
                    originalAlt: '',
                    thumbnailAlt: '',
                    renderItem: (e) => this.hideThumbs(e, this.handleLabelThumb)
                  }))
                  : [{ original: imageUrl, thumbnail: imageUrl }]
                }
              />
            </MediaQuery>
            <MediaQuery minDeviceWidth={768}>
              <ImageGallery
                showPlayButton={false}
                showFullscreenButton={false}
                useBrowserFullscreen={false}
                showNav={false}
                disableKeyDown
                disableArrowKeys
                disableSwipe
                showThumbnails={!!(images && images.length > 1)}
                items={images
                  ? images.map(img => ({
                    original: img.largeImage || img.mediumImage,
                    thumbnail: img.smallImage,
                    thumbnailClass: 'radius mt-2',
                    originalAlt: '',
                    thumbnailAlt: '',
                    renderItem: (e) => this.hideThumbs(e, this.handleLabelThumb)
                  }))
                  : [{ original: imageUrl, thumbnail: imageUrl }]
                }
              />
            </MediaQuery>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}

ProductImage.propTypes = {
  isLoading: PropTypes.bool,
  isVoucher: PropTypes.bool,
  images: PropTypes.array,
  imageUrl: PropTypes.string,
  sku: PropTypes.string
}

export default ProductImage



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductImage/ProductImage.js